module.exports = {"id":"205735","name":"Manuel Pucciarelli","rating":"74","photo":"./data/images/photos/4/205735.png","club":{"name":"Chievo Vérone","logo":"./data/images/clubs/ChievoVerone.png"},"positions":["BU","ATT"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManuelPucciarelli0.json
// module id = 2688
// module chunks = 0